import React from 'react';
import {Box} from '@mui/material';

function Gestion() {
	return (
		<Box>
			<p>Bienvenido a Jupiter</p>
		</Box>
	);
}

export default Gestion;
